export namespace TimetrackingStatusesStatic {
  export interface TimetrackingStatus {
    id: number;
    name: string;
  }

  export enum TimetrackingStatusesSearchparameters {
    name = "name"
  }
}
